_.mixin(module.exports = {
  deepClone: function(object) {
    var clone;
    clone = _.clone(object);
    _.each(clone, function(value, key) {
      if (_.isObject(value)) {
        return clone[key] = _.deepClone(value);
      }
    });
    return clone;
  },
  isBlank: function(obj) {
    if (_.isString(obj)) {
      return !/\S/.test(obj);
    } else {
      return _.isEmpty(obj);
    }
  },
  escapeRegExp: function(str) {
    if (str != null) {
      return String(str).replace(/([-.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
    } else {
      return '';
    }
  }
});

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9jb3JlL2Zyb250ZW5kL2NvbW1vbi91bmRlcnNjb3JlX21peGlucy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvVXNlcnMvanB2ZXJkZWpvL0dyb3Vwb24vc2xzL2NvcmUvZnJvbnRlbmQvY29tbW9uL3VuZGVyc2NvcmVfbWl4aW5zLmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxDQUFDLENBQUMsS0FBRixDQUFRLE1BQU0sQ0FBQyxPQUFQLEdBQ047RUFBQSxTQUFBLEVBQVcsU0FBQyxNQUFEO0FBQ1QsUUFBQTtJQUFBLEtBQUEsR0FBUSxDQUFDLENBQUMsS0FBRixDQUFRLE1BQVI7SUFDUixDQUFDLENBQUMsSUFBRixDQUFPLEtBQVAsRUFBYyxTQUFDLEtBQUQsRUFBUSxHQUFSO01BQ1osSUFBRyxDQUFDLENBQUMsUUFBRixDQUFXLEtBQVgsQ0FBSDtlQUNFLEtBQU0sQ0FBQSxHQUFBLENBQU4sR0FBYSxDQUFDLENBQUMsU0FBRixDQUFZLEtBQVosRUFEZjs7SUFEWSxDQUFkO1dBR0E7RUFMUyxDQUFYO0VBT0EsT0FBQSxFQUFTLFNBQUMsR0FBRDtJQUNQLElBQUcsQ0FBQyxDQUFDLFFBQUYsQ0FBVyxHQUFYLENBQUg7YUFDRSxDQUFJLElBQUksQ0FBQyxJQUFMLENBQVUsR0FBVixFQUROO0tBQUEsTUFBQTthQUdFLENBQUMsQ0FBQyxPQUFGLENBQVUsR0FBVixFQUhGOztFQURPLENBUFQ7RUFhQSxZQUFBLEVBQWMsU0FBQyxHQUFEO0lBQ1osSUFBRyxXQUFIO2FBQ0UsTUFBQSxDQUFPLEdBQVAsQ0FBVyxDQUFDLE9BQVosQ0FBb0IsNkJBQXBCLEVBQW1ELE1BQW5ELEVBREY7S0FBQSxNQUFBO2FBR0UsR0FIRjs7RUFEWSxDQWJkO0NBREYifQ==
